import React from 'react';
import { Layout } from '../layout/Layout';
import { PageHeader } from '../layout/PageHeader';
import ComingSoon from './ComingSoon';

interface Props {
  title: string;
  subtitle?: string;
  description?: string;
}

export const ComingSoonPage: React.FC<Props> = ({ title, subtitle, description }) => {
  return (
    <Layout>
      <div className="flex-1 w-full">
        <div className="mx-auto w-full max-w-4xl px-6 py-8 space-y-6">
          <PageHeader title={title} subtitle={subtitle || 'Coming soon'} />
          <ComingSoon title={title} description={description} />
        </div>
      </div>
    </Layout>
  );
};

export default ComingSoonPage;

